import React from "react";
import {NavLink} from "react-router-dom";

const HomeContent = () => (
  <div className="max-w-4xl mx-auto px-4 py-8">
    <div className="bg-white rounded-xl shadow-md border border-neutral-200 overflow-hidden">
      <div className="px-6 py-4 border-b border-neutral-200">
        <h2 className="text-lg font-semibold text-neutral-800">Interested and want to learn more?</h2>
        <div className="w-12 h-1 bg-blue-500 rounded mt-2"></div>
      </div>

      <div className="p-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {/* Escrow Officer */}
          <NavLink
            to="/escrow"
            className="group block p-4 rounded-lg border border-neutral-200 border-l-4 border-l-blue-500 hover:bg-blue-50/50 transition-colors"
          >
            <h3 className="font-medium text-neutral-800 group-hover:text-blue-700 mb-2">Register as an Escrow Officer</h3>
            <p className="text-sm text-neutral-600">
              Our decades of experience in the business ensure you won't be worrying if the deal will get completed. Sign up here to partner with us on your future assignments.
            </p>
          </NavLink>

          {/* Signing Agent */}
          <NavLink
            to="/sign-up"
            className="group block p-4 rounded-lg border border-neutral-200 border-l-4 border-l-green-500 hover:bg-green-50/50 transition-colors"
          >
            <h3 className="font-medium text-neutral-800 group-hover:text-green-700 mb-2">Register as a Signing Agent</h3>
            <p className="text-sm text-neutral-600">
              Quick and easy registration for signing agents and field inspectors who wish to be alerted for opportunities in their area!
            </p>
          </NavLink>

          {/* About Us */}
          <NavLink
            to="/about-us"
            className="group block p-4 rounded-lg border border-neutral-200 border-l-4 border-l-amber-500 hover:bg-amber-50/50 transition-colors"
          >
            <h3 className="font-medium text-neutral-800 group-hover:text-amber-700 mb-2">About Us</h3>
            <p className="text-sm text-neutral-600">
              Find out what makes Pinpoint Field Services the preferred solution for your needs and all about our team!
            </p>
          </NavLink>

          {/* Contact Us */}
          <NavLink
            to="/support"
            className="group block p-4 rounded-lg border border-neutral-200 border-l-4 border-l-purple-500 hover:bg-purple-50/50 transition-colors"
          >
            <h3 className="font-medium text-neutral-800 group-hover:text-purple-700 mb-2">Contact Us</h3>
            <p className="text-sm text-neutral-600">
              Have questions or need more information? Did you encounter an issue in using our service? Please contact us through this link and our team will be on it!
            </p>
          </NavLink>
        </div>
      </div>
    </div>
  </div>
);

export default HomeContent;
